import { useQuery } from "react-query";
import { getRegion } from "../../../../../actions/Utilities/Region";

export default function useRegion() {
  const {data, isFetching} = useQuery("GetRegion", getRegion, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
